// ----------------------------------------------------------------------

const breakpoints = {
  values: {
    xs: 0,
    sm: 550,
    md: 900,
    lg: 1312,
    xl: 1536
  }
};

export default breakpoints;
